export default __webpack_public_path__ + "static/media/image_1.ca083f8d.jpg";